import { useStore } from "@tanstack/react-form";
import type { StateSelector } from "../types";
import { useFormContext } from "./contexts";

export function useFormStoreAdapter<TSelected>(selector: StateSelector<TSelected>): TSelected {
    const form = useFormContext();

    return useStore(form.store, selector);
}
